import React, { useState, useRef } from "react";
import { ProgressBar } from "../../../../../Other/ProgressBar/ProgressBar";
import Dependent from "../Dependent";
import {
  CourseBuilderStaticData,
  CourseBuilderWebinar,
  CourseBundle,
} from "../../../../../../_constants/staticData";
import MultipleDropdown from "../MultipleDropdown";

const CourseCategory = ({
  formValues,
  handleSelection,
  handleInputChange,
  error,
  history,
  storedSession,
  setFormValues,
  current,
  location,
}) => {
  const Selectref = useRef();
  const selectHandler = (id) => {
    if (id === "onDemand") {
      document.getElementById("onDemand").checked = true;
      document
        .getElementById("onDemand_active")
        .classList.add("secondaryCourse-type");
      document
        .getElementById("livecourse")
        .classList.remove("secondaryCourse-type");
      setFormValues({ ...formValues, courseType: "onDemand" });
    } else if (id === "liveCourse") {
      document.getElementById("live").checked = true;
      document
        .getElementById("onDemand_active")
        .classList.remove("secondaryCourse-type");
      document
        .getElementById("livecourse")
        .classList.add("secondaryCourse-type");
      setFormValues({ ...formValues, courseType: "liveCourse" });
    } else if (id === "SelectWebinarCourse") {
      document.getElementById("WebinarCourse").classList.add("active-hover");
      document.getElementById("liveMeeting").classList.remove("active-hover");
      document.getElementById("SelectWebinarCourse").checked = true;
      setFormValues({ ...formValues, liveWebinarCourse: "liveCourse" });
    } else if (id === "liveMeetingCall") {
      document.getElementById("liveMeetingCall").checked = true;
      document.getElementById("liveMeeting").classList.add("active-hover");
      document.getElementById("WebinarCourse").classList.remove("active-hover");
      setFormValues({ ...formValues, liveWebinarCourse: "liveMeetingCall" });
    }
  };

  return (
    <>
      <div className="box text-center">
        {!location && (
          <div className={current === 4 ? "none" : "occlude"}>
            <h3 className="question-header">
              {CourseBuilderStaticData.step4.header}
            </h3>
            <p className="question-page">
              {storedSession === CourseBuilderWebinar.webinar.status
                ? CourseBuilderWebinar.step1.subHeader
                : CourseBuilderStaticData.step4.subHeader}
            </p>
            <div className="progressbar-container">
              <ProgressBar
                barMinWidth="0%"
                barWidth={
                  formValues.courseType === ""
                    ? "0%"
                    : formValues.courseType === "liveCourse"
                    ? "20%"
                    : "25%"
                }
              />
            </div>
            <div className="form-wrap-inputCourse create-options">
              <div
                className="course-type"
                onClick={() => selectHandler("onDemand")}
                id="onDemand_active"
              >
                <div id="inputdata" className="inner-course-type">
                  <input
                    aria-label="onDemand"
                    type="radio"
                    id="onDemand"
                    ref={Selectref}
                    name="courseType"
                    value="onDemand"
                    onChange={({ target }) => handleInputChange(target)}
                  />
                </div>
                <div className="schedule">
                  <label>
                    Create an <em>On Demand</em> Course
                  </label>
                </div>
              </div>

              <div
                className="course-type"
                onClick={() => selectHandler("liveCourse")}
                id="livecourse"
              >
                <div className="secondaryinner-course">
                  <input
                    aria-label="liveCourse"
                    type="radio"
                    id="live"
                    className="live"
                    name="courseType"
                    value="liveCourse"
                    onChange={({ target }) => handleInputChange(target)}
                  />
                </div>
                <div className="schedule">
                  <label>
                    Schedule A<em>LIVE</em> Event
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {!location ? (
        <>
          {storedSession === CourseBuilderWebinar.webinar.status && (
            <div className="box text-center">
              <div className={current === 5 ? "none" : "occlude"}>
                <h3 className="question-header">
                  {CourseBuilderWebinar.step2.header}
                </h3>
                <p className="question-page">
                  {CourseBuilderWebinar.step2.subHeader}
                </p>
                <div className="progressbar-container">
                  <ProgressBar
                    barMinWidth="20%"
                    barWidth={formValues.liveWebinarCourse !== "" && "40%"}
                  />
                </div>
                <div className="courseLiveStatus">
                  <ul>
                    <div id="WebinarCourse">
                      <li onClick={() => selectHandler("SelectWebinarCourse")}>
                        <input
                          aria-label="liveCourse"
                          type="radio"
                          id="SelectWebinarCourse"
                          className="live"
                          name="liveWebinarCourse"
                          value="liveWebinarCourse"
                          onChange={({ target }) => handleInputChange(target)}
                        />
                        <label> This Will be a Live Webinar Course</label>
                      </li>
                    </div>
                    <div id="liveMeeting">
                      <li
                        aria-disabled
                        style={{ backgroundColor: "lightgrey" }}
                      >
                        <input
                          aria-label="liveCourse"
                          type="radio"
                          className="live"
                          id="liveMeetingCall"
                          name="liveWebinarCourse"
                          value="liveMeetingCall"
                          disabled={true}
                          onChange={({ target }) => handleInputChange(target)}
                        />
                        <label style={{ color: "white" }}>
                          {" "}
                          This Will be a Live Meeting Call
                        </label>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="box text-center">
            <div
              className={
                current === (location === CourseBundle.CourseStatus.status && 5)
                  ? "none"
                  : "occlude"
              }
            >
              <h3 className="question-header">
                {CourseBundle.step1.header}

                {/* // What Would be the title of the Live event you Would like to create? */}
              </h3>
              <p className="question-page">
                {CourseBundle.step1.subHeader}
                {/* {CourseBuilderStaticData.step5.subHeader} */}
              </p>
              <div className="progressbar-container">
                <ProgressBar
                  barMinWidth={location === location ? "25%" : "25%"}
                  barWidth={
                    location === location &&
                    formValues.courseName !== "" &&
                    "50%"
                  }
                />
              </div>

              <div className="form-wrap-inputCourse">
                <input
                  type="text"
                  className="course-input"
                  autoComplete="off"
                  tabIndex={3}
                  placeholder="Your course bundle title Would go here"
                  maxLength={60}
                  name="courseName"
                  value={formValues.courseName}
                  onChange={({ target }) => handleInputChange(target)}
                />
              </div>
              <div className="char-counter">
                <label>
                  <p className="text-error">
                    {error &&
                      "Course Title with the exact name exists. Please update / change title accordingly."}
                  </p>
                </label>
              </div>
              <div className="char-counter">
                <label>
                  Characters remaining {formValues.courseName.length - 60}{" "}
                </label>
              </div>
            </div>
          </div>
        </>
      )}

      {!location && (
        <div className="box text-center">
          <div
            className={
              current ===
              (storedSession === CourseBuilderWebinar.webinar.status ? 6 : 5)
                ? "none"
                : "occlude"
            }
          >
            <h3 className="question-header">
              {/* {CourseBuilderStaticData.step5.header} */}
              {storedSession === CourseBuilderWebinar.webinar.status
                ? CourseBuilderWebinar.step3.header
                : CourseBuilderStaticData.step5.header}

              {/* // What Would be the title of the Live event you Would like to create? */}
            </h3>
            <p className="question-page">
              {storedSession === CourseBuilderWebinar.webinar.status
                ? CourseBuilderWebinar.step3.subHeader
                : CourseBuilderStaticData.step5.subHeader}
              {/* {CourseBuilderStaticData.step5.subHeader} */}
            </p>
            <div className="progressbar-container">
              <ProgressBar
                barMinWidth={storedSession === "liveCourse" ? "40%" : "25%"}
                barWidth={
                  storedSession === "liveCourse"
                    ? formValues.courseName !== "" && "60%"
                    : formValues.courseName !== "" && "50%"
                }
              />
            </div>

            <div className="form-wrap-inputCourse">
              <input
                type="text"
                className="course-input"
                autoComplete="off"
                tabIndex={3}
                placeholder="Your Course title Would go here"
                maxLength={60}
                name="courseName"
                value={formValues.courseName}
                onChange={({ target }) => handleInputChange(target)}
              />
            </div>
            <div className="char-counter">
              <label>
                <p className="text-error">
                  {error &&
                    "Course Title with the exact name exists. Please update / change title accordingly."}
                </p>
              </label>
            </div>
            <div className="char-counter">
              <label>
                Characters remaining {formValues.courseName.length - 60}{" "}
              </label>
            </div>
          </div>
        </div>
      )}
      {/* {formValues.liveWebinarCourse === "liveMeetingCall" && (
        <div className="box text-center">
          <div>
            <h3 className="question-header">
              Can you add some more details to the description for this meet?
            </h3>
            <p className="question-page">Step 4/5</p>
            <div className="progressbar-container">
              <ProgressBar
                barMinWidth={formValues.courseName !== "" && "60%"}
                barWidth={
                  storedSession === "liveCourse" &&
                  formValues.meetDescription !== "" &&
                  "80%"
                }
              />
            </div>

            <div className="form-wrap-inputCourse">
              <textarea
                name="meetDescription"
                rows="4"
                cols="50"
                placeholder="Short description for this meet"
                className="custom-input"
                value={formValues.meetDescription}
                onChange={({ target }) => handleInputChange(target)}
              />
            </div>
          </div>
        </div>
      )}
      {formValues.liveWebinarCourse === "liveMeetingCall" && (
        <div className="box text-center">
          <div>
            <h3 className="question-header">Please confirm invitees list</h3>
            <p className="question-page">Step 5 / 5</p>
            <div className="progressbar-container">
              <ProgressBar
                barMinWidth={formValues.meetDescription !== "" && "80%"}
                barWidth={formValues.invite !== "" && "100%"}
              />
            </div>

            <div className="form-wrap-inputCourse">
              <textarea
                name="invite"
                rows="4"
                cols="50"
                placeholder="Please type or paste emails seperated bu commas i.e adam@something.com, steve@something.com,ariah@something.com"
                className="custom-input"
                value={formValues.invite}
                onChange={({ target }) => handleInputChange(target)}
              />
            </div>
          </div>
        </div>
      )} */}
      {!location ? (
        <div className="box text-center">
          <div
            className={
              current ===
              (storedSession === CourseBuilderWebinar.webinar.status ? 7 : 6)
                ? "none"
                : "occlude"
            }
          >
            <h3 className="question-header">
              {storedSession === CourseBuilderWebinar.webinar.status
                ? CourseBuilderWebinar.step4.header
                : CourseBuilderStaticData.step6.header}
            </h3>
            <p className="question-page">
              {storedSession === CourseBuilderWebinar.webinar.status
                ? CourseBuilderWebinar.step4.subHeader
                : CourseBuilderStaticData.step6.subHeader}
            </p>
            <div className="progressbar-container">
              <ProgressBar
                barMinWidth={storedSession === "liveCourse" ? "80%" : "75%"}
                barWidth="80%"
              />
            </div>

            <div className="form-wrap-inputCourse">
              <Dependent
                selectionHandler={handleInputChange}
                formValues={formValues}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="box text-center">
          <div
            className={
              current === (location === CourseBundle.CourseStatus.status && 6)
                ? "none"
                : "occlude "
            }
          >
            <h3 className="question-header">{CourseBundle.step2.header}</h3>
            <p className="question-page">{CourseBundle.step2.subHeader}</p>
            <div className="progressbar-container">
              <ProgressBar
                barMinWidth={
                  location === CourseBundle.CourseStatus.status ? "80%" : "75%"
                }
                barWidth="80%"
              />
            </div>

            <div className="form-wrap-inputCourse">
              <MultipleDropdown
                handleInputChange={handleSelection}
                formValues={formValues}
                location={location}
                setFormValues={setFormValues}
              />
            </div>
          </div>
        </div>
      )}

      {!location ? (
        <div className="box text-center">
          <div
            className={
              current ===
              (storedSession === CourseBuilderWebinar.webinar.status ? 8 : 7)
                ? "none"
                : "occlude"
            }
          >
            <h3 className="question-header">
              {storedSession === CourseBuilderWebinar.webinar.status
                ? CourseBuilderWebinar.step5.header
                : CourseBuilderStaticData.step7.header}
            </h3>
            <p className="question-page">
              {storedSession === CourseBuilderWebinar.webinar.status
                ? CourseBuilderWebinar.step5.subHeader
                : CourseBuilderStaticData.step7.subHeader1}
            </p>
            <div className="progressbar-container">
              <ProgressBar
                barMinWidth={storedSession === "liveCourse" ? "80%" : "75%"}
                barWidth="100%"
              />
            </div>

            <div className="form-wrap-inputCourse">
              <div className="category-item">
                <select
                  tabIndex={6}
                  aria-label="category"
                  className="category"
                  onChange={({ target }) => handleInputChange(target)}
                >
                  <option value="0" defaultValue={true}>
                    No
                  </option>
                  <option value="1">Yes</option>
                </select>
              </div>
            </div>
            <div className="note">
              <p>
                {CourseBuilderStaticData.step7.subHeader2}
                <a
                  tabIndex="-1"
                  href="https://edusity.com/privacy"
                  target="_blank"
                >
                  Privacy Policy
                </a>
                ,{" "}
                <a
                  tabindex="-1"
                  href="https://edusity.com/terms"
                  target="_blank"
                >
                  Terms of Use
                </a>{" "}
                &amp;{" "}
                <a
                  tabIndex="-1"
                  href="https://edusity.com/mature-guidelines"
                  target="_blank"
                >
                  Mature Content Guidelines
                </a>{" "}
                as per your local legislation. Thank You!
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="box text-center">
          <div
            className={
              current === (location === CourseBundle.CourseStatus.status && 7)
                ? "none"
                : "occlude"
            }
          >
            <h3 className="question-header">{CourseBundle.step3.header}</h3>
            <p className="question-page">{CourseBundle.step3.subHeader}</p>
            <p className="question-page">{CourseBundle.step3.subheader}</p>
            <div className="progressbar-container">
              <ProgressBar
                barMinWidth={
                  location === CourseBundle.CourseStatus.status ? "80%" : "75%"
                }
                barWidth="100%"
              />
            </div>

            <div className="form-wrap-inputCourse">
              <div className="category-item">
                <select
                  tabIndex={6}
                  aria-label="category"
                  className="category"
                  onChange={({ target }) => handleInputChange(target)}
                >
                  <option value="0" defaultValue={true}>
                    No
                  </option>
                  <option value="1">Yes</option>
                </select>
              </div>
            </div>
            <div className="note">
              <p>
                {CourseBuilderStaticData.step7.subHeader2}
                <a
                  tabindex="-1"
                  href="https://edusity.com/privacy"
                  target="_blank"
                >
                  Privacy Policy
                </a>
                ,{" "}
                <a
                  tabindex="-1"
                  href="https://edusity.com/terms"
                  target="_blank"
                >
                  Terms of Use
                </a>{" "}
                &amp;{" "}
                <a
                  tabIndex="-1"
                  href="https://edusity.com/mature-guidelines"
                  target="_blank"
                >
                  Mature Content Guidelines
                </a>{" "}
                as per your local legislation. Thank You!
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default CourseCategory;
